


























































































































































































import VueOptions from '@utils/VueOptions'
import MemberNotes from '@modules/ui/notes/MemberNotes'
import SuperNotes from '@modules/ui/notes/SuperNotes'
import states from '@assets/states.json'
import dma from '@assets/dma.json'

settings = 
  name: 'ScannerForm'
  components: { MemberNotes, SuperNotes }
  resources:
    events: 
      resourceName: 'event'
      slug: 'scanners/:scannerId/events'
  vue:  
    props: ['item', 'options', 'context']

    data: ->
      member_note: null
      super_note: null

      state_options: states
      dma_options: dma

      filterTimeout: null
      shouldFetchEvents: true

    methods:
      hiAddMemberNote: ->
        return if !@member_note.length
        @item.new_member_notes.push @member_note
        @member_note = ''

      hiAddSuperNote: ->
        return if !@super_note.length
        @item.new_super_notes.push @super_note
        @super_note = ''
      
      fetchEvents: ->
        if (@shouldFetchEvents)
          @fetch('events', @combinedFilters())
        else
          @shouldFetchEvents = !@shouldFetchEvents
      
      combinedFilters: ->
        scopes = @formatScopes()

        filters = {}
        for k, v of @item.single_filters
          filters[k] = v if v

        multi_filters = {}
        for k, v of @item.multi_filters
          multi_filters[k] = v if v.length

        return { scopes, filters, multi_filters }

      formatScopes: ->
        ctx = this
        Object.keys(@item.scopes).filter((key) -> key if ctx.item.scopes[key]).join(',')

    watch:
      item:
        handler: ->
          ctx = this

          clearTimeout(@filterTimeout)
          @filterTimeout = setTimeout(() ->
            ctx.fetchEvents()
          , 500)
        
        deep: true

export default VueOptions.vue settings
